module.exports = __webpack_public_path__ + "static/img/logo.32f569c8.png";